
import { createContext, useState } from 'react';
import Todo from './Todo/Todo';
import Main from './Tools/Main';
import InitHrm from './HRM/InitHrm';
import Home from './Intro/Home';
import { Routes, Route } from 'react-router-dom';
import PasswordReset from './Auth/PasswordReset';
import CompanyReg from './Auth/CompanyReg';

function App() {

  return (
   <>
    {/* <Main />    */}
   {/* <Todo /> */}
   
   <Routes>
    <Route path='/' element={<Home />}></Route>
    <Route path='/home' element={<InitHrm />}></Route>
    <Route path='/resetpass' element={<PasswordReset />}></Route>
    <Route path='/register_company' element={<CompanyReg />}></Route>

   </Routes>

   </>
  );
}

export default App;
